import { observable, flow, action } from "mobx";
import { queryCurrent } from "services/user";
import { RouterState } from "mobx-state-router";
import { login, logout } from "services/api";
import { setCurrentUser, getCurrentUser } from "utils/authority";
import { removeCurrentUser } from "../utils/authority";
import { message } from "antd";
const defaultRoute = new RouterState("campaigns");
const loginRoute = new RouterState("login");

export default class UserStore {
	rootStore;
	@observable
	currentUser = {
		name: null
	};

	@observable status = null;

	signInRedirect = defaultRoute;

	constructor(rootStore) {
		this.rootStore = rootStore;
		this.currentUser.name = getCurrentUser();
	}

	// @action
	setSignInRedirect(routerState) {
		this.signInRedirect = routerState;
	}

	resetSignInRedirect() {
		this.setSignInRedirect(defaultRoute);
	}
	// fetchCurrentUser = flow(function*() {
	// 	const response = yield queryCurrent();
	// 	if (response == null) {
	// 		return;
	// 	}

	// 	if (response.error) {
	// 		return;
	// 	}

	// 	this.currentUser.name = response.name;
	// });

	@action
	changeStatus = function(status) {
		this.status = status;
	}

	remoteLogin = flow(function*(payload) {
		const response = yield login(payload);
		if (response == null) {
			this.status = "Server Error";
			return;
		}
		if (response.status == "ok") {
			this.status = "ok";
			this.currentUser.name = response.name;
			setCurrentUser(this.currentUser.name);
			let signInRedirect = this.signInRedirect;
			this.resetSignInRedirect();
			this.rootStore.routerStore.goTo(signInRedirect);
			return;
		} else {
			this.status = response.status;			
			return;
		}
	});

	@action
	remoteLogout = flow(function*() {
		const response = yield logout();
		if (response == null) {
			message.error("Something wrong while trying to logout", 3);
			return;
		}
		if (response.error) {
			message.error("Failed to log out. Error: " + response.error.message, 3);
			return;
		}
		this.currentUser.name = null;
		removeCurrentUser();
		this.resetSignInRedirect();
		this.rootStore.routerStore.goTo(loginRoute);
	});
}
